import styles from "./vmTransfer.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import VmAgentTransfer from "./vmAgentTransfer";
import store from "../../../../store/redux-store/root_store";
import { meetActionTypes } from "../../../../base/action/action";

function VideoTransfer() {
  const dispatch = useDispatcher();
  const navigate = useNavigate();


  useEffect(() => {
  }, [])

  const closeAgentList=()=>{
    let {vm_acd_event,vmTransferTimer}:any=store.getState().meetingReducer;
    store.dispatch({
      type:meetActionTypes.VM_TRANSFER,
      payload:{
        vmTransfer:false,
        vm_acd_event:vm_acd_event,
        vmTransferDropdown:false,
        vmTransferDetails:{}
      }
    })
  }

  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <div className={styles.closeTransfer}>
          <span className={styles.transTitle}>Agent Transfer</span>
          <span
            className="icon__IconCloseNew16"
          onClick={closeAgentList}></span>
        </div>
            <VmAgentTransfer />
      </div>
    </>
  );
}
export default VideoTransfer;
